// @ts-nocheck
import { ordertrackingInitialApi as api } from './initialApi';
export const addTagTypes = ['order-controller'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getDeliveredOrders: build.mutation<
        GetDeliveredOrdersApiResponse,
        GetDeliveredOrdersApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-05-19/orders/delivered`,
          method: 'POST',
          body: queryArg.deliveredOrdersListDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      getOrdersV20260505: build.mutation<
        GetOrdersV20260505ApiResponse,
        GetOrdersV20260505ApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-05-05/orders/list`,
          method: 'POST',
          body: queryArg.ordersListV20260505Dto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            includeAutoImportedOrders: queryArg.includeAutoImportedOrders,
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      exportOrdersV20260505: build.mutation<
        ExportOrdersV20260505ApiResponse,
        ExportOrdersV20260505ApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-05-05/orders/export`,
          method: 'POST',
          body: queryArg.ordersExportV20260505Dto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
          params: {
            includeAutoImportedOrders: queryArg.includeAutoImportedOrders,
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      autoImport: build.mutation<AutoImportApiResponse, AutoImportApiArg>({
        query: (queryArg) => ({
          url: `/2026-04-07/auto-import`,
          method: 'POST',
          body: queryArg.autoImportRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      addOrders: build.mutation<AddOrdersApiResponse, AddOrdersApiArg>({
        query: (queryArg) => ({
          url: `/2024-06-01/orders`,
          method: 'POST',
          body: queryArg.orderCodesDto,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      getOrders: build.mutation<GetOrdersApiResponse, GetOrdersApiArg>({
        query: (queryArg) => ({
          url: `/2024-06-01/orders/list`,
          method: 'POST',
          body: queryArg.ordersListDto,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      exportOrders: build.mutation<ExportOrdersApiResponse, ExportOrdersApiArg>(
        {
          query: (queryArg) => ({
            url: `/2024-06-01/orders/export`,
            method: 'POST',
            body: queryArg.ordersListDto,
            headers: {
              'x-bd-organization': queryArg['x-bd-organization'],
            },
          }),
          invalidatesTags: ['order-controller'],
        }
      ),
      deleteOrders: build.mutation<DeleteOrdersApiResponse, DeleteOrdersApiArg>(
        {
          query: (queryArg) => ({
            url: `/2024-06-01/orders/bulkremove`,
            method: 'POST',
            body: queryArg.removeCodesDto,
            headers: {
              'x-bd-organization': queryArg['x-bd-organization'],
            },
          }),
          invalidatesTags: ['order-controller'],
        }
      ),
      excludeOrders: build.mutation<
        ExcludeOrdersApiResponse,
        ExcludeOrdersApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-04-21/orders/exclude`,
          method: 'PATCH',
          body: queryArg.excludeOrdersRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      getOrderFilters: build.query<
        GetOrderFiltersApiResponse,
        GetOrderFiltersApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-05-05/orders/filters`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
          params: {
            includeAutoImportedOrders: queryArg.includeAutoImportedOrders,
          },
        }),
        providesTags: ['order-controller'],
      }),
      getOrderCount: build.query<GetOrderCountApiResponse, GetOrderCountApiArg>(
        {
          query: (queryArg) => ({
            url: `/2026-04-07/orders/count`,
            headers: {
              'cs-organization': queryArg['cs-organization'],
            },
            params: {
              fan: queryArg.fan,
              afterTimestamp: queryArg.afterTimestamp,
              afterTimeInterval: queryArg.afterTimeInterval,
            },
          }),
          providesTags: ['order-controller'],
        }
      ),
      getOrder: build.query<GetOrderApiResponse, GetOrderApiArg>({
        query: (queryArg) => ({
          url: `/2024-06-01/orders/${queryArg.orderCode}`,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        providesTags: ['order-controller'],
      }),
      getOrderSummary: build.query<
        GetOrderSummaryApiResponse,
        GetOrderSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-06-01/orders/summary`,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            includeAutoImportedOrders: queryArg.includeAutoImportedOrders,
          },
        }),
        providesTags: ['order-controller'],
      }),
      softDeleteOrders: build.mutation<
        SoftDeleteOrdersApiResponse,
        SoftDeleteOrdersApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-04-21/orders`,
          method: 'DELETE',
          body: queryArg.softDeleteRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as ordertrackingApi };
export type GetDeliveredOrdersApiResponse =
  /** status 200 OK */ GmResponseCommonDeliveredOrdersPageDto;
export type GetDeliveredOrdersApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
  deliveredOrdersListDto: DeliveredOrdersListDto;
};
export type GetOrdersV20260505ApiResponse =
  /** status 200 OK */ GmResponseCommonOrdersPageV20260505Dto;
export type GetOrdersV20260505ApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Continuation token returned in the previous response's continuationToken field. Omit or leave blank for the first page. */
  'cs-continuation-token'?: string;
  /** If true, includes orders where ingestionType is AUTO_IMPORT in addition to MANUAL and
                        legacy orders; if false (default), only MANUAL or unset ingestionType are returned. */
  includeAutoImportedOrders?: boolean;
  ordersListV20260505Dto: OrdersListV20260505Dto;
};
export type ExportOrdersV20260505ApiResponse = /** status 200 OK */ CsvRowDto[];
export type ExportOrdersV20260505ApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** If true, includes orders where ingestionType is AUTO_IMPORT in addition to MANUAL and
                        legacy orders; if false (default), only MANUAL or unset ingestionType are returned. */
  includeAutoImportedOrders?: boolean;
  ordersExportV20260505Dto: OrdersExportV20260505Dto;
};
export type AutoImportApiResponse =
  /** status 200 OK */ GmResponseCommonAutoImportResponseDto;
export type AutoImportApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  autoImportRequestDto: AutoImportRequestDto;
};
export type AddOrdersApiResponse =
  /** status 200 OK */ GmResponseCommonAddOrdersDto;
export type AddOrdersApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  orderCodesDto: OrderCodesDto;
};
export type GetOrdersApiResponse =
  /** status 200 OK */ GmResponseCommonOrdersPageDto;
export type GetOrdersApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  ordersListDto: OrdersListDto;
};
export type ExportOrdersApiResponse = /** status 200 OK */ CsvRowDto[];
export type ExportOrdersApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  ordersListDto: OrdersListDto;
};
export type DeleteOrdersApiResponse =
  /** status 200 OK */ GmResponseCommonListString;
export type DeleteOrdersApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  removeCodesDto: RemoveCodesDto;
};
export type ExcludeOrdersApiResponse =
  /** status 200 OK */ GmResponseCommonExcludeOrdersResponseDto;
export type ExcludeOrdersApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  excludeOrdersRequestDto: ExcludeOrdersRequestDto;
};
export type GetOrderFiltersApiResponse =
  /** status 200 OK */ GmResponseCommonOrderFiltersDto;
export type GetOrderFiltersApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /**
                        If true, includes all orders (manual, auto-imported, and legacy);
                        if false (default), only MANUAL or unset ingestionType.
                     */
  includeAutoImportedOrders?: boolean;
};
export type GetOrderCountApiResponse =
  /** status 200 OK */ GmResponseCommonOrdersCountDto;
export type GetOrderCountApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet Account Number. */
  fan?: string;
  /** ISO 8601 instant (e.g. 2026-10-07T01:01:00Z). When provided, only orders whose updatedAt is on or after this timestamp are included. When absent, all orders are returned. */
  afterTimestamp?: string;
  /** Number of minutes (0–1440 or 24 hours) to subtract from afterTimestamp to widen the query window. Only applies when afterTimestamp is provided. Defaults to 0. */
  afterTimeInterval?: number;
};
export type GetOrderApiResponse =
  /** status 200 OK */ GmResponseCommonSingleOrderDto;
export type GetOrderApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  orderCode: string;
};
export type GetOrderSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonMapStatusInteger;
export type GetOrderSummaryApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  /**
                        If true, includes AUTO_IMPORT orders in the per-status counts;
                        if false (default), only MANUAL or unset ingestionType orders are counted.
                     */
  includeAutoImportedOrders?: boolean;
};
export type SoftDeleteOrdersApiResponse =
  /** status 200 OK */ GmResponseCommonDeletedOrdersDto;
export type SoftDeleteOrdersApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  softDeleteRequestDto: SoftDeleteRequestDto;
};
export type DeliveredOrderVehicleDto = {
  vin?: string;
  make?: string;
  model?: string;
  year?: number;
  imageUrl?: string;
};
export type DeliveredOrdersPageDto = {
  items: DeliveredOrderVehicleDto[];
  totalItems?: number;
  continuationToken?: string;
};
export type GmResponseError = {
  errorType: 'GENERIC' | 'VALIDATION';
  message: string;
  errorCode: string;
};
export type GmResponseCommonDeliveredOrdersPageDto = {
  result?: DeliveredOrdersPageDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommon = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DeliveredOrdersFilterDto = {
  vehicleImportStatus?: ('IMPORTED' | 'OFFBOARD_REQUESTED')[];
  updatedAfter?: string;
};
export type DeliveredOrdersListDto = {
  filter?: DeliveredOrdersFilterDto;
  fan: string;
  itemsPerResponse: number;
};
export type OrderTrackingFleetDto = {
  id: string;
  name: string;
};
export type ImageUrlsDto = {
  thumb: string;
  full: string;
  large: string;
  views: string[];
};
export type VehicleDetailsDto = {
  vehicleName?: string;
  imageUrls: ImageUrlsDto;
  make: string;
  model: string;
  year: number;
  vin?: string;
  trim?: string;
  color?: string;
  interiorColor?: string;
};
export type DealerAddressDto = {
  street: string;
  city: string;
  province: string;
  country: string;
  postalCode: string;
  latitude: string;
  longitude: string;
};
export type DealerDto = {
  code: string;
  name: string;
  phone: string;
  address: DealerAddressDto;
};
export type StatusHistoryDto = {
  status:
    | 'ORDERED'
    | 'ACCEPTED'
    | 'PRODUCED'
    | 'SHIPPED'
    | 'AT_DEALERSHIP'
    | 'DELIVERED'
    | 'CANCELED';
  statusAt?: string;
};
export type SingleOrderDto = {
  code: string;
  orderedAt?: string;
  status:
    | 'ORDERED'
    | 'ACCEPTED'
    | 'PRODUCED'
    | 'SHIPPED'
    | 'AT_DEALERSHIP'
    | 'DELIVERED'
    | 'CANCELED';
  statusAt?: string;
  statusDetails?: string;
  parentCode?: string;
  fleet?: OrderTrackingFleetDto;
  targetProductionDate?: string;
  estimatedDeliveryDate?: string;
  vehicleDetails: VehicleDetailsDto;
  dealer?: DealerDto;
  statusHistory?: StatusHistoryDto[];
  updatedAt?: string;
  updatedBy?: string;
  fan?: string;
};
export type OrdersPageV20260505Dto = {
  items: SingleOrderDto[];
  totalItems?: number;
  continuationToken?: string;
};
export type GmResponseCommonOrdersPageV20260505Dto = {
  result?: OrdersPageV20260505Dto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrdersListV20260505FilterDto = {
  make?: string[];
  year?: number[];
  status?: (
    | 'ORDERED'
    | 'ACCEPTED'
    | 'PRODUCED'
    | 'SHIPPED'
    | 'AT_DEALERSHIP'
    | 'DELIVERED'
    | 'CANCELED'
  )[];
  lastLoginDate?: string;
  orderCode?: string[];
  excludeOrder?: string[];
};
export type OrdersListV20260505Dto = {
  filter?: OrdersListV20260505FilterDto;
  itemsPerResponse: number;
};
export type CsvRowDto = {
  code: string;
  orderedAt?: string;
  status:
    | 'ORDERED'
    | 'ACCEPTED'
    | 'PRODUCED'
    | 'SHIPPED'
    | 'AT_DEALERSHIP'
    | 'DELIVERED'
    | 'CANCELED';
  statusAt?: string;
  statusDetails?: string;
  parentCode?: string;
  fleetId?: string;
  fleetName?: string;
  targetProductionDate?: string;
  estimatedDeliveryDate?: string;
  vehicleName?: string;
  vehicleMake?: string;
  vehicleModel?: string;
  vehicleYear?: number;
  vehicleVin?: string;
  vehicleTrim?: string;
  vehicleColor?: string;
  vehicleInteriorColor?: string;
  updatedAt?: string;
  updatedBy?: string;
};
export type OrdersExportV20260505Dto = {
  filter?: OrdersListV20260505FilterDto;
};
export type AutoImportResponseDto = {
  /** Current status of the auto-import operation */
  status: 'COMPLETED' | 'IN_PROGRESS' | 'FAILED';
  /** Total order count found in UIV for the lookup criteria */
  totalFromUIV: number;
  /** Number of orders that already existed in the system */
  existingCount: number;
  /** Number of new orders being imported */
  newOrdersCount: number;
};
export type GmResponseCommonAutoImportResponseDto = {
  result?: AutoImportResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AutoImportRequestDto = {
  /** Fleet Assigned Number to import orders for */
  fan: string;
};
export type AddOrdersDto = {
  created: string[];
  existed: string[];
  missing: string[];
  revived: string[];
};
export type GmResponseCommonAddOrdersDto = {
  result?: AddOrdersDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetDto = {
  /** Fleet ID */
  id: string;
  /** Fleet name */
  name: string;
};
export type OrderCodesDto = {
  /** List of codes to be processed */
  codes: string[];
  /** Fleet info */
  fleet?: FleetDto;
};
export type OrdersPageDto = {
  items: SingleOrderDto[];
  totalItems?: number;
  previousToken?: string;
  token?: string;
  nextToken?: string;
  firstPageItemIndex: number;
};
export type GmResponseCommonOrdersPageDto = {
  result?: OrdersPageDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FilterBy = any;
export type ListFilter = FilterBy & {
  oneOfValues: string[];
};
export type Range = {
  min: string;
  max: string;
};
export type RangeFilter = FilterBy & {
  range: Range;
};
export type OrdersListDto = {
  sort?: {
    [key: string]: 'ASC' | 'DESC';
  };
  filter?: {
    [key: string]: ListFilter | RangeFilter;
  };
  token?: string;
  itemsPerResponse: number;
};
export type GmResponseCommonListString = {
  result?: string[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RemoveCodesDto = {
  codes: string[];
};
export type ExcludeOrdersResponseDto = {
  updated: string[];
  failed: string[];
};
export type GmResponseCommonExcludeOrdersResponseDto = {
  result?: ExcludeOrdersResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ExcludeOrdersRequestDto = {
  vins: string[];
};
export type OrderFiltersDto = {
  makes: string[];
  modelYears: number[];
  statuses: (
    | 'ORDERED'
    | 'ACCEPTED'
    | 'PRODUCED'
    | 'SHIPPED'
    | 'AT_DEALERSHIP'
    | 'DELIVERED'
    | 'CANCELED'
  )[];
};
export type GmResponseCommonOrderFiltersDto = {
  result?: OrderFiltersDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AutoImportRedisStatus = {
  status: 'COMPLETED' | 'IN_PROGRESS' | 'FAILED';
  total: number;
  processed: number;
  fan: string;
};
export type OrdersCountDto = {
  manuallyAddedCount: number;
  autoImportedCount: number;
  totalCount: number;
  autoImportRedisStatus?: AutoImportRedisStatus;
};
export type GmResponseCommonOrdersCountDto = {
  result?: OrdersCountDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonSingleOrderDto = {
  result?: SingleOrderDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonMapStatusInteger = {
  result?: {
    [key: string]: number;
  };
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DeletedOrdersDto = {
  deleted: string[];
  failed: string[];
};
export type GmResponseCommonDeletedOrdersDto = {
  result?: DeletedOrdersDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SoftDeleteRequestDto = {
  orders: string[];
  excludeOrder?: string[];
  deletionInitiatorRole:
    | 'TECHNICAL_MANAGER'
    | 'SYSTEM_MANAGER'
    | 'ORG_MANAGER'
    | 'HUB_MANAGER'
    | 'FLEET_MANAGER'
    | 'OPERATOR'
    | 'SYSTEM_READER'
    | 'VIEWER';
};
export const {
  useGetDeliveredOrdersMutation,
  useGetOrdersV20260505Mutation,
  useExportOrdersV20260505Mutation,
  useAutoImportMutation,
  useAddOrdersMutation,
  useGetOrdersMutation,
  useExportOrdersMutation,
  useDeleteOrdersMutation,
  useExcludeOrdersMutation,
  useGetOrderFiltersQuery,
  useGetOrderCountQuery,
  useGetOrderQuery,
  useGetOrderSummaryQuery,
  useSoftDeleteOrdersMutation,
} = injectedRtkApi;
